const baseUrl = 'https://redspeedapidev.redstarplc.com/api'
export default baseUrl;

// Login
// ximitap903@keyido.com
// password:password
